import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 22px 26px 23px;
  box-sizing: border-box;
  border-radius: ${({ borderRadius }) => borderRadius}px;
  border: 0.71px solid ${({ theme }) => theme.border.black10};
  height: 100%;
  background-color: ${({ theme, isTemplate }) => theme.bg.card};

  ${({ isList }) => {
    if (isList) {
      return `
        display: grid;
        grid-template-columns: 1fr 1px 1fr;
      `;
    }
    return `
      display: flex;
      flex-direction: column;
    `;
  }}
  gap: 28px;

  ${({ hasLink }) => hasLink && `cursor: pointer;`}
`;

export const TitleTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 10.4px;
  height: 100%;
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.text.title};
  font-size: 22px;
  font-weight: 600;
  line-height: 24px;
  position: relative;
`;

export const Subtitle = styled.div`
  color: #acacac;
  font-size: 14px;
  font-weight: 400;
  line-height: 130%;
  position: relative;
  white-space: pre-line;
`;

export const Divider = styled.div`
  background-color: ${({ theme }) => theme.border.black10};
  height: ${({ isList }) => (isList ? "100%" : "1px")};
  width: ${({ isList }) => (isList ? "1px" : "100%")};
`;

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DetailWrapper = styled.div`
  padding: 15px 18px;
  height: 50px;
  box-sizing: border-box;
  border-radius: 100px;
  background-color: ${({ isActive, clr }) => {
    if (!isActive) return "transparent";
    const colorOpacity10 = clr.slice(0, 7);
    return `${colorOpacity10}1a`;
  }};

  display: flex;
  align-items: center;
  justify-content: space-between;

  color: ${({ clr }) => clr || "#003bff"};
  font-size: 14px;
  font-weight: 500;
`;

export const Details = styled.div`
  display: flex;
  align-items: center;
  column-gap: 7px;
`;

export const AttendButton = styled.div`
  display: inline-flex;
  padding: 4px 20px;
  justify-content: center;
  align-items: center;
  border-radius: 24px;
  background: ${({ bgClr, textClr, inverse }) => (inverse ? textClr : bgClr)};
  color: ${({ bgClr, textClr, inverse }) => (inverse ? bgClr : textClr)};
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 23.202px;
  letter-spacing: -0.5px;
  min-height: 32px;
  cursor: pointer;
`;
